import { GuiBase } from "../GuiBase";

export class GuiHome extends GuiBase {

    constructor() {
        super("Home");
    }

}
